import React, { useEffect } from 'react';
import '../Style/GoalCelebration.css';

// We replaced 'message' with 'completedCount' and 'totalCount'
const GoalCelebration = ({ isVisible, onClose, completedCount, totalCount }) => {
  
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000); 
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  // Internal Logic: Choose the message based on progress
  const getGameMessage = () => {
    if (completedCount === totalCount && totalCount > 0) {
      return "LEGENDARY! Every single goal is finished! 👑🏆";
    }
    
    const percentage = (completedCount / totalCount) * 100;
    
    if (percentage >= 75) return "Almost there! You're unstoppable! 🔥";
    if (percentage >= 50) return "Halfway point! The momentum is real! 🚀";
    if (percentage >= 25) return "Great pace! Keep stacking those wins! 💪";
    
    return "First win of the day! Great start! ✨";
  };

  const isFinalGoal = completedCount === totalCount && totalCount > 0;

  return (
    <div className={`celebration-overlay ${isFinalGoal ? 'final-boss' : ''}`}>
      <div className="celebration-card">
        <div className="celebration-icon">
          {isFinalGoal ? "👑" : "🏆"}
        </div>
        <div className="celebration-text">
          <h3>{isFinalGoal ? "MISSION COMPLETE" : "Goal Smashed!"}</h3>
          <p>{getGameMessage()}</p>
        </div>
      </div>
    </div>
  );
};

export default GoalCelebration;